import { useSearchParams } from "@src/appV2/lib/utils/useSearchParams";
import { useSetSearchParams } from "@src/appV2/lib/utils/useSetSearchParams";
import constate from "constate";
import { useState } from "react";

import { PILL_TABS_OPTIONS, type PillTabOption, type PillTabSearchParams } from "./types";

function useDocumentsPageNavigation() {
  const { tab } = useSearchParams<PillTabSearchParams>();
  const setSearchParams = useSetSearchParams();

  const [selectedTabState, setSelectedTabState] = useState<PillTabOption>(
    PILL_TABS_OPTIONS.includes(tab) ? tab : PILL_TABS_OPTIONS[0]
  );

  function setSelectedTab(tab: PillTabOption) {
    setSelectedTabState(tab);
    setSearchParams({ tab }, { shouldReplace: true });
  }

  return {
    selectedTab: selectedTabState,
    setSelectedTab,
  };
}

export const [DocumentsPageNavigationProvider, useDocumentsPageNavigationContext] = constate(
  useDocumentsPageNavigation
);
